import React, { useState } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import { Accordion, AccordionDetails, AccordionSummary, Skeleton } from '@mui/material';
import './index.sass';

const { block, el } = bem('slide-down');

const SlideDown = ({ question, answer, expanded, onClick }) => {

    return (
        <div className={block()}>
            <Accordion disableGutters={true} expanded={expanded} onClick={onClick}>
                <AccordionSummary
                    expandIcon={<Icon name={'caret-down'} />}
                >
                    <div className={el('question')}>
                        <Text>{ question }</Text>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <div className={el('answer')}>
                        <Text dangerouslySetInnerHTML={{__html: answer}} />
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export const SlideDownSkeleton = () => {
    return (
        <div className={block()}>
            <Accordion disableGutters={true}>
                <AccordionSummary
                    expandIcon={ null }
                >
                    <div className={el('question')}>
                        <Text><Skeleton width={`${70 + Math.random() * 30}%`}/></Text>
                    </div>
                </AccordionSummary>
            </Accordion>
        </div>
    )
}

export default SlideDown;
